import { ApAssertion, Assertion, ServiceOffering } from "@idw-types/data/reference-data/generic";
import { FormattedServiceAssertionPerformance, ServiceAssertionPerformance } from "@idw-types/data/reports/service-assertion-performance";
import { formatApAssertion } from "../ap-assertions/ap-assertion-formatter";

export const formatServiceAssertionPerformances = (
    serviceAssertionPerformances: Array<ServiceAssertionPerformance>,
    apAssertions: Array<ApAssertion>,
    assertions: Array<Assertion>,
    serviceOfferings: Array<ServiceOffering>
): Array<FormattedServiceAssertionPerformance> => {
    return serviceAssertionPerformances.map(sap => formatServiceAssertionPerformance(sap, apAssertions, assertions, serviceOfferings));
};

export const formatServiceAssertionPerformance = (
    serviceAssertionPerformance: ServiceAssertionPerformance,
    apAssertions: Array<ApAssertion>,
    assertions: Array<Assertion>,
    serviceOfferings: Array<ServiceOffering>
): FormattedServiceAssertionPerformance => {
    const apAssertion = apAssertions.find(apa => +apa.id === serviceAssertionPerformance.apAssertionID);
    const formattedApAssertion = apAssertion ? formatApAssertion(apAssertion, assertions, serviceOfferings) : null;
    return {
        apAssertion: formattedApAssertion,
        baselineCloseAssertionPercent: serviceAssertionPerformance.baselineCloseAssertionPercent,
        baselineFailAssertionPercent: serviceAssertionPerformance.baselineFailAssertionPercent,
        baselinePartialAssertionPercent: serviceAssertionPerformance.baselinePartialAssertionPercent,
        baselinePassAssertionPercent: serviceAssertionPerformance.baselinePassAssertionPercent,
        baselineUnverifiedAssertionPercent: serviceAssertionPerformance.baselineUnverifiedAssertionPercent,
        closeAssertionPercent: serviceAssertionPerformance.closeAssertionPercent,
        failAssertionPercent: serviceAssertionPerformance.failAssertionPercent,
        partialAssertionPercent: serviceAssertionPerformance.partialAssertionPercent,
        passAssertionPercent: serviceAssertionPerformance.passAssertionPercent,
        unverifiedAssertionPercent: serviceAssertionPerformance.unverifiedAssertionPercent,
        failTrustScoreModifier: serviceAssertionPerformance.failTrustScoreModifier,
        passAssertionScorePoints: serviceAssertionPerformance.passAssertionScorePoints
    };
};